import './TeamUserDetailForm.css';
import "../JobDetailForm/JobDetailForm.css";

import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button } from 'react-bootstrap';
import { useCookies } from 'react-cookie';

const TeamUserDetailForm = ({ user_object = null, closeModal = null, triggerReload = null }) => {
  const [user, setUser] = useState(user_object || { first_name: '', last_name: '', email: '', active: true });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [cookies] = useCookies(['AuthorizationToken']);

  const isEditing = Boolean(user_object && user_object.user_id);

  const handleChange = (field, value) => {
    setUser(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);

    try {
      if (isEditing) {
        const response = await axios.put(`https://api.foveaai.com/evaluate/web/user/profile`, {
          user_id: user.user_id,
          ...user
        }, { headers: { Authorization: cookies.AuthorizationToken } });
        if (response.status !== 200) throw new Error(response.data?.message || 'Failed to update team user.');
      } else {
        const response = await axios.post('https://api.foveaai.com/evaluate/web/team/user/profile', user, {
          headers: { Authorization: cookies.AuthorizationToken }
        });
        if (response.status !== 200) throw new Error(response.data?.message || 'Failed to add team user.');
      }

      if (triggerReload) triggerReload();
      if (closeModal) closeModal();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'An unexpected error occurred.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="job-detail-container">
      <div className="job-modal">
        <div className="job-modal-header">
          <div className="header-left">
            <div className="job-modal-title">{isEditing ? 'Edit Team User' : 'Add Team User'}</div>
          </div>
          {closeModal && (
            <button type="button" className="close-btn" onClick={closeModal} aria-label="Close">✕</button>
          )}
        </div>

        {/* No progress bar or side checklist for this form */}

        <Form onSubmit={handleSubmit}>
          <div className="job-modal-body">
            <div className="job-main-content">
              <div className="tab-content">
                <div className="quick-tips">
                  <div className="tips-icon">👥</div>
                  <div className="tips-content">
                    <div className="tips-title">Invite teammates</div>
                    <div className="tips-text">Add team members to collaborate and manage evaluations together.</div>
                  </div>
                </div>

                <div className="team-user-detail-form-groups">
                  <Form.Group>
                    <Form.Label className="modern-label">First Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={user.first_name || ''}
                      onChange={(e) => handleChange('first_name', e.target.value)}
                      required
                      className="modern-input"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="modern-label">Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={user.last_name || ''}
                      onChange={(e) => handleChange('last_name', e.target.value)}
                      required
                      className="modern-input"
                    />
                  </Form.Group>

                  {isEditing ? (
                    <Form.Group>
                      <Form.Label className="modern-label">Active</Form.Label>
                      <div>
                        <Form.Check
                          type="switch"
                          checked={Boolean(user.active)}
                          onChange={(e) => handleChange('active', e.target.checked)}
                          label={user.active ? 'Active' : 'Inactive'}
                        />
                      </div>
                    </Form.Group>
                  ) : (
                    <Form.Group>
                      <Form.Label className="modern-label">Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={user.email || ''}
                        onChange={(e) => handleChange('email', e.target.value)}
                        required
                        className="modern-input"
                      />
                    </Form.Group>
                  )}
                </div>

                {error && (
                  <div className="error-confirmation" style={{ marginTop: 12 }}>
                    <h2>Error</h2>
                    <p>{error}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="job-modal-footer">
            {closeModal && (
              <Button variant="secondary" className="btn-modern-secondary" onClick={closeModal} disabled={saving} type="button">
                Cancel
              </Button>
            )}
            <Button variant="success" type="submit" className="btn-modern-primary" disabled={saving}>
              {isEditing ? 'Update User' : 'Add User'}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default TeamUserDetailForm;
